import { blob, form } from '@/lib/fetch';

export function extractWtbClipboardText(content: string): string {
  return content
    .split('\n')
    .map((line) => line.trim().replace(/^(?:[-*•]|\d+[.)])\s+/, ''))
    .filter((line) => line.startsWith('WTB '))
    .join('\n');
}

export async function copyFillingMessages(text: string): Promise<boolean> {
  const value = text.trim();
  if (!value) return false;
  await navigator.clipboard.writeText(value);
  return true;
}

/** Call during the click or keydown. The text can arrive later and still land on the clipboard. */
export function armFillingClipboard(textPromise: Promise<string>): void {
  const write = navigator.clipboard?.write?.bind(navigator.clipboard);
  if (write && typeof ClipboardItem !== 'undefined') {
    const item = new ClipboardItem({
      'text/plain': textPromise.then((text) => {
        const value = text.trim();
        if (!value) throw new Error('Nothing to copy');
        return new Blob([value], { type: 'text/plain' });
      }),
    });
    void write([item]).catch(() => undefined);
    return;
  }
  void textPromise.then((text) => copyFillingMessages(text)).catch(() => undefined);
}

/** Start the zip download in the same turn as the user gesture. */
export function startFillingImageDownload(href: string): void {
  const a = document.createElement('a');
  a.href = href;
  a.download = 'wtb-images.zip';
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export async function downloadFillingImages(href: string): Promise<void> {
  const data = await blob(href);
  if (!data) throw new Error('Failed to download images');
  const url = window.URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'wtb-images.zip';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(url), 1500);
}

/** Pass `imageUrls` to download those photos instead of the orders' own. */
export function fillingImagesPath(orderIds: string[], imageUrls: string[] = []): string | undefined {
  const ids = [...new Set(orderIds.filter(Boolean))];
  if (ids.length === 0) return;
  const images = imageUrls.map((url) => `&image=${encodeURIComponent(url)}`).join('');
  return `/api/orders/outgoing/filling-images?ids=${ids.join(',')}${images}`;
}

/** Uploads a photo for one WTB post, leaving the order's own image alone. */
export async function uploadWtbImage(file: File): Promise<string> {
  const fd = new FormData();
  fd.append('image', file);
  const res = (await form('/api/inventory/whatsapp/image', fd)) as { image_url?: string };
  if (!res.image_url) throw new Error('Upload did not return an image URL');
  return res.image_url;
}
